export default "__VITE_ASSET__d2ZFNPX___"